export const cleanFormData = (rawData) => {
    const out = {};
    Object.keys(rawData).forEach((key) => {
        if (rawData[key]) {
            out[key] = rawData[key];
        }
    });
    return out;
};
